export default __webpack_public_path__ + "static/media/battery-100.10d5ad49.svg";